import { LATEX_CONTROL } from './sanitizeTsaProseMath';

/**
 * Put back the backslash on LaTeX commands that were eaten as JSON string
 * escapes when the question was imported.
 *
 * `"\\frac"` written as `"\frac"` inside a JSON string parses as FORM FEED plus
 * "rac", and `"\times"` as TAB plus "imes". The stored text therefore holds a
 * control character where the backslash should be, so the maths does not
 * typeset and renders as "19.6ext{%}". It also breaks the surrounding `$...$`
 * pairing, which smashes the prose between the amounts.
 *
 * Only restores when the result is a command in LATEX_CONTROL. That matters:
 * one TMUA explanation contains a vertical tab inside the word "effort", which
 * would otherwise become "e\vort". A control character in exam HTML is never
 * meaningful whitespace, but it is not always a lost backslash either.
 */
const ESCAPE_LETTER = { 8: 'b', 9: 't', 11: 'v', 12: 'f' };

export function restoreMangledLatexEscapes(text) {
  if (typeof text !== 'string' || !text) return text || '';
  if (!/[\b\t\v\f]/.test(text)) return text;
  return text.replace(/[\b\t\v\f]([a-zA-Z]+)/g, (full, rest) => {
    const letter = ESCAPE_LETTER[full.charCodeAt(0)];
    if (!letter) return full;
    const candidate = `\\${letter}${rest}`;
    return LATEX_CONTROL.test(candidate) ? candidate : full;
  });
}
